const ITEMS = [
    { text: "My village", mono: false },
    { text: "Uttar Pradesh", mono: true },
    { text: "School days", mono: false },
    { text: "UP → Bengaluru", mono: true },
    { text: "College years", mono: false },
    { text: "Family first", mono: true },
    { text: "Freelance + AI", mono: true },
    { text: "Recent builds", mono: false },
];

const Group = ({ hidden }) => (
    <div className="marquee-group" aria-hidden={hidden || undefined}>
        {ITEMS.map((it) => (
            <span key={it.text} className="flex items-center">
                <span
                    className={`whitespace-nowrap px-8 ${
                        it.mono
                            ? "font-mono text-sm uppercase tracking-[0.3em] text-terracotta"
                            : "font-display text-2xl italic text-ink sm:text-3xl"
                    }`}
                >
                    {it.text}
                </span>
                <span className="h-1.5 w-1.5 flex-shrink-0 rounded-full bg-sage" />
            </span>
        ))}
    </div>
);

export const Marquee = () => (
    <section
        data-testid="editorial-marquee"
        className="marquee relative z-10 border-y border-line bg-parchment/85 py-6 backdrop-blur-sm"
    >
        <div className="marquee-track">
            <Group />
            <Group hidden />
        </div>
    </section>
);

export default Marquee;
